import React,{useEffect} from 'react';
import TDPBroadcaster from 'src/components/TDP/TDPBroadcaster';
import {makeAppTopMod} from "src/utilities/utilityFunctions";
import {connect} from "react-redux";
import Container from 'react-bootstrap/Container';
import {obtainMediaTypes} from "src/services/gameTime/ApiServices";

import {processTokenData,currMainMod,mainHeight} from "src/containers/gameTime/GameTimeWelcome/welcomeFunctions";
import KidsLifeHeader from "src/components/TDP/HomePage/KidsLifeHeader";
import {returnHeightOf} from "src/containers/foundation/foundationFunctions";
import {obtainFAQs} from "src/services/TDP/APIServices";
import TDPDataManager from "src/components/TDP/Structure/TDPDataManager";
import {whoIsOnline} from "src/components/gameTimeMyRoom/WhoIsOnLine";
import {gameSettings} from "src/containers/TDP/TDPWebsiteFunctions";
import GameTimeTeamManager from "src/components/gameTimeTeams/GameTimeTeamsManager";
import WebSocketMonitor from "src/components/websockets/WebSocketMonitor";
import DistractionPanel from "src/components/TDP/Distractions/DistractionPanel";
import store from 'src/store';

const mainContentStyle = (props) => {
    let calcHeight = mainHeight(props);
    return {
        maxHeight: calcHeight,
        height: calcHeight,
        //position: "relative",
        //paddingTop: "16px",
        paddingLeft: "4px",
        paddingRight: "4px"
    }
};

const welcomeStyle = {height:"100%",maxHeight:"100%",padding:"0px"};

const runSetUp = () => {
    let retme=[];
    //eslint-disable-next-line
    try{processPage(jQuery)}catch(err){}
    retme.push("processPage");
    obtainMediaTypes();
    retme.push("obtainMediaTypes");
    //preLoadText();
    //retme.push("preLoadText");

    obtainFAQs();
    retme.push("obtainFAQs");
    gameSettings();
    retme.push("gameSettings");


    whoIsOnline();
    retme.push("whoIsOnline");

    return retme;
};


const TDPWelcome = (props) =>{
    let stateData = store.getState();
    useEffect(()=> {
        runSetUp();
        //eslint-disable-next-line
    },[]);

    let tokens=JSON.stringify(props.appSettings.tokenData);
    useEffect(()=>{
        processTokenData();
    },[tokens]);

    let currentMainMod = currMainMod();

    useEffect(()=>{
        makeAppTopMod(currentMainMod);
    },[currentMainMod]);

    let processedStyle = props.height ? {height:props.height,maxHeight:props.height} : {};
    //let navHeight = returnHeightOf("utilityNav");
    let mainContentHeight = props.height ? props.height : "100%";
    let topNav = (props.appSettings.hideTopNav
        ? null
        : <KidsLifeHeader/>

    );
    let headerHeight = returnHeightOf("kidslifeheader");
    let mainModule = (props.dataStore.appMainModule
        ? <props.dataStore.appMainModule height={mainContentHeight-headerHeight} />
        : <span id={"defaultWelcome"}>Welcome {store.getState().appSettings.breakpoint}</span>
    );
    // return (
    //     <Container fluid style={Object.assign({},welcomeStyle,processedStyle)} id="welcomeWrapper" className="wrapper">
    //         <WebSocketMonitor/>
    //         <TDPBroadcaster />
    //         <TDPDataManager />
    //         <GameTimeTeamManager/>
    //         <div style={Object.assign({},mainContentStyle(props),{height:mainContentHeight,maxHeight:mainContentHeight,padding:0})} id="mainContent">
    //             {topNav}
    //             {mainModule}
    //         </div>
    //         <DistractionPanel/>
    //     </Container>
    // );
    return (
        <div id="welcomeWrapper" style={{width:'100vw',height:'100vh',backgroundImage:'linear-gradient(to right, white, white)'}}>
            <WebSocketMonitor/>
            <TDPBroadcaster />
            <TDPDataManager />
            <GameTimeTeamManager/>
            <div style={Object.assign({},mainContentStyle(props),{height:mainContentHeight,maxHeight:mainContentHeight,padding:0,width:'100vw'})} id="mainContent">
                {topNav}
                {mainModule}
            </div>
            <DistractionPanel/>
        </div>
    );
};

const mapStateToProps = (state) =>{
    return {
        appSettings:state.appSettings,
        gameTime:state.gameTime,
        dataStore:state.dataStore,
        state:state
    };
};

export default connect(mapStateToProps,{})(TDPWelcome);
